type iconsLib = {
  [name: string]: {
    color: string;
    paths: string[];
  };
}

export const icons: iconsLib = {
  survey: {
    color: '#313133',
    paths: [
      "M22.98 4.44c-10.2 0-18.49 7.18-18.49 16a14.06 14.06 0 00.78 4.6l4.17 14.41a.74.74 0 00.56.52.78.78 0 00.15.02.74.74 0 00.57-.27l4.08-4.93a20.95 20.95 0 008.18 1.65c10.2 0 18.49-7.18 18.49-16s-8.3-16-18.5-16zm0 30.52a19.37 19.37 0 01-8.09-1.74.74.74 0 00-.88.2l-3.53 4.28-3.8-13.09v-.03a12.55 12.55 0 01-.7-4.14c0-8 7.62-14.52 17-14.52s17 6.51 17 14.52-7.62 14.52-17 14.52z",
      "M22.93 17.71a2.67 2.67 0 102.67 2.67 2.67 2.67 0 00-2.67-2.67zm0 3.86a1.19 1.19 0 111.19-1.19 1.19 1.19 0 01-1.19 1.19zM29.42 17.71a2.67 2.67 0 102.67 2.67 2.67 2.67 0 00-2.67-2.67zm0 3.86a1.19 1.19 0 111.19-1.19 1.19 1.19 0 01-1.19 1.19zM16.54 17.71a2.67 2.67 0 102.66 2.67 2.67 2.67 0 00-2.66-2.67zm0 3.86a1.19 1.19 0 111.18-1.19 1.19 1.19 0 01-1.18 1.19z"
    ],
  },
  'survey-active': {
    color: '#000',
    paths: [
      "M22.488 5C12.288 5 4 12.179 4 21a14.043 14.043 0 00.777 4.605l4.176 14.412a.739.739 0 001.281.266l4.071-4.929a20.942 20.942 0 008.182 1.648c10.194 0 18.488-7.179 18.488-16S32.682 5 22.488 5zm-6.442 18.609a2.666 2.666 0 112.666-2.666 2.666 2.666 0 01-2.666 2.666zm6.394 0a2.666 2.666 0 112.666-2.666 2.666 2.666 0 01-2.666 2.666zm6.489 0a2.666 2.666 0 112.666-2.666 2.667 2.667 0 01-2.666 2.666z",
      "M28.929 19.762a1.186 1.186 0 101.186 1.186 1.186 1.186 0 00-1.186-1.186z",
      "M22.487 19.762a1.186 1.186 0 101.186 1.186 1.186 1.186 0 00-1.186-1.186z",
      "M16.046 19.762a1.186 1.186 0 101.186 1.186 1.186 1.186 0 00-1.186-1.186z",
    ],
  },
  maps: {
    color: '#313133',
    paths: [
      "M22.67 4.2A13.69 13.69 0 009 17.87c0 6.1 8.59 16.93 12.28 21.3a1.82 1.82 0 002.78 0c3.7-4.37 12.28-15.2 12.28-21.3A13.69 13.69 0 0022.67 4.2zm.35 34.1a.46.46 0 01-.7 0 105.98 105.98 0 01-7.1-9.4c-3.17-4.8-4.85-8.62-4.85-11.03a12.3 12.3 0 0124.61 0c0 2.41-1.68 6.23-4.86 11.03a106.2 106.2 0 01-7.1 9.39z",
      "M22.67 11.37a5.69 5.69 0 105.7 5.7 5.7 5.7 0 00-5.7-5.7zm0 10.02A4.32 4.32 0 1127 17.06a4.33 4.33 0 01-4.32 4.33z",
    ],
  },
  'maps-active': {
    color: '#000',
    paths: [
      "M22.672 4A13.687 13.687 0 009 17.672c0 6.108 8.588 16.933 12.28 21.3a1.821 1.821 0 002.566.218 1.8 1.8 0 00.218-.218c3.692-4.371 12.28-15.2 12.28-21.3A13.686 13.686 0 0022.672 4zm0 18.553a5.689 5.689 0 115.688-5.688 5.69 5.69 0 01-5.686 5.69z",
      "M22.674 12.542a4.322 4.322 0 104.321 4.322 4.322 4.322 0 00-4.321-4.322z",
    ],
  },
  quiz: {
    color: '#313133',
    paths: [
      "M23 5.92A17.08 17.08 0 115.92 23 17.1 17.1 0 0123 5.92m0-1.41A18.5 18.5 0 1041.5 23 18.5 18.5 0 0023 4.5z",
      "M23.23 27.73h-1.45V22l.59-.1c5.15-.95 6.21-2.6 6.21-4.8 0-3.19-3.23-3.66-5.16-3.66a5.43 5.43 0 00-5.83 5.04l-1.44-.18c.46-3.9 3.25-6.31 7.27-6.31 4.14 0 6.61 1.9 6.61 5.1 0 4.06-3.35 5.41-6.8 6.11zM22.6 29.49a2.67 2.67 0 102.66 2.66 2.67 2.67 0 00-2.67-2.66zm0 3.85a1.19 1.19 0 111.18-1.19 1.19 1.19 0 01-1.19 1.19z",
    ],
  },
  'quiz-active': {
    color: '#000',
    paths: [
      "M22.493 4a18.493 18.493 0 1018.493 18.493A18.494 18.494 0 0022.493 4zm-.407 30.31a2.666 2.666 0 112.666-2.666 2.667 2.667 0 01-2.666 2.666zm.632-11.6v4.511h-1.45V21.51l.594-.109c5.155-.946 6.212-2.6 6.212-4.8 0-3.183-3.233-3.658-5.16-3.658a5.427 5.427 0 00-5.831 4.99v.048l-1.44-.172c.464-3.9 3.252-6.316 7.275-6.316 4.139 0 6.609 1.91 6.609 5.108-.004 4.052-3.35 5.403-6.809 6.106z",
      "M22.086 30.458a1.186 1.186 0 101.186 1.186 1.186 1.186 0 00-1.186-1.186z",
    ],
  },
  profile: {
    color: '#313133',
    paths: [
      "M37.34 33.73l-9.13-5.33a1.76 1.76 0 01-.87-1.52v-.35a1.77 1.77 0 01.75-1.44 9.56 9.56 0 004.07-7.8V11.9c0-3.73-2.42-6.48-6.64-7.55a12.05 12.05 0 00-6.02 0c-4.22 1.08-6.64 3.83-6.64 7.55v5.4a9.55 9.55 0 004.06 7.8 1.77 1.77 0 01.76 1.43v.34a1.76 1.76 0 01-.89 1.52l-9.1 5.19a3.22 3.22 0 00-1.62 2.78v3.32a1.35 1.35 0 001.35 1.35h30.13a1.36 1.36 0 001.36-1.33l.02-3.17a3.21 3.21 0 00-1.59-2.8zm.1 5.85H7.54v-3.22a1.76 1.76 0 01.9-1.52l9.1-5.2a3.21 3.21 0 001.61-2.78v-.33a3.22 3.22 0 00-1.37-2.62 8.1 8.1 0 01-3.44-6.62V11.9c0-4.12 3.47-5.62 5.53-6.15a10.55 10.55 0 015.3 0c2.07.53 5.54 2.03 5.54 6.15v5.4a8.11 8.11 0 01-3.45 6.61 3.21 3.21 0 00-1.37 2.63v.35a3.22 3.22 0 001.6 2.76l9.13 5.33a1.76 1.76 0 01.88 1.53z"
    ],
  },
  'profile-active': {
    color: '#000',
    paths: [
      "M36.451 32.901l-8.889-5.2a1.722 1.722 0 01-.852-1.481v-.342a1.727 1.727 0 01.737-1.407 9.333 9.333 0 003.955-7.606v-5.27c0-3.637-2.354-6.322-6.458-7.369a11.7 11.7 0 00-5.866 0c-4.106 1.049-6.46 3.735-6.46 7.369v5.262a9.33 9.33 0 003.955 7.606 1.73 1.73 0 01.737 1.407v.327a1.72 1.72 0 01-.866 1.488l-8.859 5.064a3.139 3.139 0 00-1.581 2.715v3.243a1.319 1.319 0 001.322 1.313h29.325a1.322 1.322 0 001.322-1.3l.026-3.1a3.137 3.137 0 00-1.548-2.719z"
    ]
  },
  plus: {
    color: '#e3064a',
    paths: [
      "M41.04 22.55a.68.68 0 00-.69-.69h-16.5V5.04a.68.68 0 10-1.36 0v16.82H5.67a.68.68 0 000 1.37h16.82v16.5a.68.68 0 101.37 0v-16.5h16.5a.68.68 0 00.68-.69z",
    ],
  },
  'triangle-left': {
    color: '#E3064A',
    paths: [
      "M28.809 9.9l1.32 1.287v23.067l-1.32 1.254L13.565 23.7v-2.26z",
      "M13.552 24.324l14.446 11.257a1.615 1.615 0 001 .355 1.935 1.935 0 001.785-2.053V11.366a1.935 1.935 0 00-1.785-2.053 1.609 1.609 0 00-1 .355L13.552 20.924a2.232 2.232 0 000 3.4zm.667-2.264l14.445-11.256a.527.527 0 01.329-.12.645.645 0 01.6.686v22.513a.645.645 0 01-.6.686.528.528 0 01-.33-.12L14.218 23.192a.743.743 0 010-1.132z",
    ]
  },
  'triangle-right': {
    color: '#E3064A',
    paths: [
      "M16.191 35.1l-1.32-1.287V10.746l1.32-1.254L31.435 21.3v2.26z",
      "M31.448 20.676L17.002 9.419a1.615 1.615 0 00-1-.355 1.935 1.935 0 00-1.785 2.053v22.517a1.935 1.935 0 001.785 2.053 1.609 1.609 0 001-.355l14.446-11.256a2.232 2.232 0 000-3.4zm-.667 2.264L16.336 34.196a.527.527 0 01-.329.12.645.645 0 01-.6-.686V11.117a.645.645 0 01.6-.686.528.528 0 01.33.12l14.445 11.257a.743.743 0 010 1.132z",
    ]
  }
}

  
export function getIconHtml(icon: {paths: string[]; color: string}, size?: number): string {
  if(size === undefined) {
    size = 45
  }
  const paths = icon.paths.map(p => `<path d="${p}" />`)
  return `<svg xmlns="http://www.w3.org/2000/svg" height="${size}" width="${size}" viewBox="0 0 45 45"><g fill="${icon.color}">${paths.join()}</g></svg>`
}